module.exports = __webpack_public_path__ + "media/images/icon-checkbox-on-b434ed04471c1db32838045825e2bfed.svg";